import { PrimaryTextColor, boldFont, getRelativeFontSize, mediumFont, heading, primaryBlueColor, primaryLightGray, primaryWhiteColor, regularFont, subHeading, PrimaryLightTextColor } from "../../../../utils/styles";

const ShowAllStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  pageHeading: {
    ...heading,
  },
  autoInputFill: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(-3),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-inputFocused": {
      fontSize: getRelativeFontSize(-3),
    },
    "& .css-t3lsui-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":{
      padding: "2px 5px",
      fontSize: getRelativeFontSize(-3),
    },
  },
  content: {
    padding: "0 70px",
  },
  checkBoxWarapper: {
    diplay: "flex",
    marginTop: "10px",
  },
  autocomplateStyle: {
    width: "100%",
    maxHeight:'38px',
    background: "#e7e7e7",
    "& .MuiSvgIcon-root ":{
      display:"none"
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "0.5px 9px",
    },
    "&  .MuiTextField-root": {
      maxHeight:'38px',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display:'flex',
      flexWrap: "initial",
      overflow:'hidden',
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiChip-label":{
      fontSize:"11px",
      padding:"0 8px",
    },
    "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
      fontSize:"16px",
    },
  },
  pageSubHeading: {
    ...subHeading,
  },
  statusHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...mediumFont,
  },
  showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
  },
  menuPart:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
  },
  datePickerBox:{
    margin:"0",
    width:"40%",

    "& .MuiFormLabel-root":{
      fontSize: getRelativeFontSize(0),
      top:"-3px",
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      padding:"12px 10px",
    },
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    width:"25%",

    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
    flexDirection: "column",
    "& button": {
      color: primaryBlueColor,
      height: "10px",
      fontSize: getRelativeFontSize(-2),
    },
  },

  buttonWrapperDialog: {
    width: "350px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    "& button": {
      color: primaryBlueColor,
      fontSize: getRelativeFontSize(-2),
      "&:nth-child(2)": {
        color: "#ffffff",
      },
    },
  },

  rowtext: {
    ...mediumFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-3),
    display: "flex",
    alignItems: "center",
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },

  fullName: {
    ...regularFont,
    fontcolor: "#0C0E2E",
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
  },

  emp_type_btn: {
    background: "#18CB8A",
    width: "60px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: getRelativeFontSize(-4),
    textTransform: "capitalize",
    ...regularFont,
    borderRadius: "4px",
    color: "#ffffff",
  },

  activeBtn: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
    },
  },

  deActive: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
      background: "red",
      borderColor: "red",
      "&:hover": {
        background: "red",
        borderColor: "red",
      },
    },
  },

  popOverContent: {
    position: "relative",
    top: "20px",
  },

  popOverBtn: {
    position: "absolute",
  },

  Info_btn: {
    height: "18px",
    width: "fit-content",
    padding: "0 10px",
    ...regularFont,
    borderRadius: "4px",
    background: "#F4BE5E",
    fontSize: getRelativeFontSize(-4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5px",
    color: "#ffffff",
    textTransform: "capitalize",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    "& button": {
      width: "fit-content",
      height:"32px",
      "&:hover": {
        background: "none",
      },
    },
  },
  customgridStyle:{
    "& .css-yrdy0g-MuiDataGrid-columnHeaderRow":{
      display: "flex",
    justifyContent: "space-between",
    },

  },
 
  tableCustom:{
    color:"red"
  }
  
};

export default ShowAllStyles;
